var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"clearfix tag-navigator tag-navigator-{{$ctrl.layout}}\" ng-style=\"$ctrl.layout==='wrapped-accordion'&&{'max-height': ($ctrl.maxHeight||550) + 'px'}\"><a ng-bind=\"item.label\" ng-repeat=\"item in $ctrl.accordionItems\" class=\"text-truncate tag-navigator-accordion-item\" ng-class=\"item.classes\" ng-style=\"{'max-width': ($ctrl.maxColumnWidth||180) + 'px'}\" ng-click=\"item.select()\"></a></div>";
var id1="tag-navigator-accordion.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;